import React from 'react'
import styles from '../component-styles/bubble.module.scss'

interface TriangleProps {
  direction?: 'left' | 'right' | 'none'
}

export function Triangle({ direction }: TriangleProps): React.ReactElement {
  return (
    <div
      className={styles.triangle}
      style={{
        left: direction === 'left' ? '0' : 'auto',
        right: direction === 'right' ? '0' : 'auto',
        transform: `translateY(-50%) translateX(${
          direction === 'left' ? '' : '-'
        }50%)`,
      }}
    >
      <svg
        viewBox="0 0 100 100"
        style={{ transform: `rotate(${direction === 'left' ? 45 : 225}deg)` }}
      >
        <polygon points="0, 0 0, 100 100, 100" />
      </svg>
    </div>
  )
}

Triangle.defaultProps = {
  direction: 'left',
}

interface Props {
  direction?: 'left' | 'right' | 'none'
  children?: React.ReactNode
  className?: string
}

export default function Bubble({
  children,
  direction,
  className,
}: Props): React.ReactElement {
  let padding = ''
  if (direction === 'left') {
    padding = '0 0 0 20px'
  } else if (direction === 'right') {
    padding = '0 20px 0 0'
  }
  return (
    <div className={`${styles.container} ${className}`} style={{ padding }}>
      <div className={styles.inner}>
        {direction !== 'none' && <Triangle direction={direction} />}
        {children}
      </div>
    </div>
  )
}

Bubble.defaultProps = {
  direction: 'left',
}
